import "moment/locale/ru"
import initYandexMetrika from "src/helpers/initYandexMetrika"
import env from "src/env"

const { REACT_APP_YANDEX_METRIKA_COUNTER_ID } = env

export default App => () => {
  if (REACT_APP_YANDEX_METRIKA_COUNTER_ID) {
    initYandexMetrika(REACT_APP_YANDEX_METRIKA_COUNTER_ID)
  }

  return {
    App,
  }
}
